import React from 'react';
import styled from 'styled-components';
import Tile from './Tile';

const TileBoard = ({ tiles, onTileClick, selectableTiles = [], selectedTile = null }) => {
  return (
    <BoardContainer>
      <BoardGrid>
        {tiles.map((tile, index) => (
          <Tile 
            key={tile.id || index}
            tile={tile}
            onClick={() => onTileClick(tile, index)}
            isSelectable={selectableTiles.includes(tile.id)}
            isSelected={selectedTile && selectedTile.id === tile.id}
          />
        ))}
      </BoardGrid>
    </BoardContainer>
  );
};

const BoardContainer = styled.div`
  width: 100%;
  padding: 10px;
  background-color: #2a6d3e;
  border-radius: 8px;
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.3);
`;

const BoardGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px;
`;

export default TileBoard;
